import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var resize_corner_n_e_default = /* @__PURE__ */ jsx(SVG, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(Path, { d: "M7 18h4.5v1.5h-7v-7H6V17L17 6h-4.5V4.5h7v7H18V7L7 18Z" }) });
export {
  resize_corner_n_e_default as default
};
//# sourceMappingURL=resize-corner-n-e.js.map
